import { getTags, updateTag, deleteTag, createTag } from "../../api/tag";
import { toArray, toObject } from "../../utils/languageContent";
import { checkPermission } from "../../utils/PermissionUtils";

const tag = {
    namespaced: true,
    state: {
        tags: {
            data: [],
        },
        selectedTag: null,
    },
    getters: {},
    mutations: {
        SET_TAGS: (state, payload) => {
            state.tags = payload;
        },
        ADD_TAG: (state, payload) => {
            state.tags.data.push(payload);
        },
        UPDATE_TAG: (state, payload) => {
            const index = state.tags.data.findIndex((p) => p._id === payload._id);
            state.tags.data[index] = payload;
        },
        DELETE_TAG: (state, id) => {
            state.tags.data = state.tags.data.filter((r) => r._id !== id);
        },
    },
    actions: {
        async getTags({ commit }, type = 'contact') {
            const tags = await getTags(type).then((res) => res.data);
            const data = tags.map((x) => toObject(x));
            commit("SET_TAGS", { data });
            return tags;
        },
        setTags({ commit }, tags) {
            const data = tags.map((x) => toObject(x));
            commit("SET_TAGS", { data });
        },
        createTag({ commit }, payload) {
            return createTag(toArray(payload)).then((response) => {
                commit("ADD_TAG", toObject(response.data));
                return Promise.resolve(response);
            });
        },
        updateTag({ commit }, payload) {
            return updateTag(payload).then((response) => {
                commit("UPDATE_TAG", toObject(response.data));
            });
        },
        deleteTag({ commit }, id) {
            return deleteTag(id).then((response) => {
                commit("DELETE_TAG", id);
            });
        },
    },
};
export default tag;
